<template>
  <div class="main">
    <Header 
      :show="true"
      title="添加产品"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c" background="#FFFBE8" 
      text="注意：产品名称不能跟现有的名称一样"
      />
      
      <van-form 
        ref="create"
        @submit="submit"
      >
        <van-field
        v-model.trim="listQuery.name"
        label="名称"
        placeholder="请输入产品名称"
        required
        :rules="[{ validator: validName, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.standard"
        label="规格"
        placeholder="请输入产品规格"
        required
        :rules="[{ validator: validName, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.unit"
        label="单位"
        placeholder="请输入产品单位"
        required
        :rules="[{ validator: validName, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.remark"
        rows="2"
        autosize
        label="说明"
        type="textarea"
        maxlength="100"
        placeholder="请输入产品说明"
        show-word-limit
        :rules="[{ validator: validName, message: '' }]"
      />
      <div style="margin: .6rem 1rem;" v-if="checkPermission([192])">
        <van-button round block type="info" native-type="submit">
          确定
        </van-button>
      </div>
    </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isUserName, isPassword, isChinese, isPhone, isEmail } from '@/utils/validate.js'
  import { createOne } from '@/api/product.js'

  export default {
    name: "ServiceSystemProductCreate",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        isLoading: false,
        loading: false,
        listQuery: {
          name: '',
          standard: '',
          unit: '',
          remark: ''
        },
        loading: false
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$refs.create.submit()
      },
      submit() {
        Dialog.confirm({
          title: '确认新增产品？',
          message: '产品名称：' + this.listQuery.name
        }).then(() => {
          this.loading = true
          const data = {
            name: this.listQuery.name,
            standard: this.listQuery.standard,
            unit: this.listQuery.unit,
            remark: this.listQuery.remark
          }
          createOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '新增产品', data.message)) {
              this.$router.push({ path:'/service/system/product', query: {} })
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '新增产品', '取消')
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 5em;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox__icon {
    font-size: 4.5vw;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
